import RpcService  from '@/core/services/Rpc/RpcService';
import RpcResponse from '@/core/services/Rpc/RpcResponse';

import type Vehicle           from '@/domains/Vehicles/Vehicle';
import type RpcDataPagination from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort       from '@/core/services/Rpc/RpcDataSort';

/**
 * DAO для работы с транспортами
 */
class VehiclesDAO {

	static async getList(
		filters?: {
      id?: number;
      vehicleTypeId?: number;
      pattern?: string;
      name?: string;
    },
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'vehicles.getList',
			filters,
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	static async add(vehicle: Vehicle): Promise<RpcResponse> {
		return await RpcService.makeRequest('vehicles.add', { vehicle });
	}

	static async update(vehicle: Vehicle): Promise<RpcResponse> {
		return await RpcService.makeRequest('vehicles.update', { vehicle });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('vehicles.delete', { id });
	}
}

export default VehiclesDAO;
